var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#424F62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-502 -803) translate(497 798) translate(5.5 5.5) translate(0 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.806 0 0 3.806 0 8.5S3.806 17 8.5 17 17 13.194 17 8.5 13.194 0 8.5 0zm0 15.355c-3.786 0-6.855-3.07-6.855-6.855 0-3.786 3.07-6.855 6.855-6.855 3.786 0 6.855 3.07 6.855 6.855 0 1.818-.722 3.562-2.008 4.847-1.285 1.286-3.029 2.008-4.847 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.677 8.226H9.322V12.613H7.677z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 5.758,
    r: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIButton);
export default __webpack_public_path__ + "static/media/iButton.e01408c0ea7755898b17f85d1925fce2.svg";
export { ForwardRef as ReactComponent };